import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';
export const walletAgreementCode = 'WalletContract';

const getContractState = (state: AppState) => state.contractState;

export const getUserContracts = createSelector(getContractState, state => Object.values(state.entities));
export const getContractById = (id: string) => createSelector(getContractState, state => state.entities[id]);
export const getBuyTradeOptionContractState = createSelector(
	getUserContracts,
	state => state.find(a => a.codeName === 'TradeOptionContract')?.confirmState
);

export const getSellTradeOptionContractState = createSelector(
	getUserContracts,
	state => state.find(a => a.codeName === 'ShortSell')?.confirmState
);
